import ActionTypes from "../constants/ActionTypes";

const initialState = {
    isSuccess: false,
    hasError: false,
    isLoading: false,
    dataSearch: {}
};

export default (state = initialState, action) => {
    const { type, payload } = action;
    switch (type) {
        case ActionTypes.SEARCH_SUCCESS:
            return {
                ...state,
                isSuccess: true,
                hasError: false,
                isLoading: false,
                dataSearch: payload
            };
        case ActionTypes.SEARCH_FAILURE:
            return {
                ...state,
                hasError: true,
                isLoading: false
            };
        case ActionTypes.SEARCH_IS_LOADING:
            return {
                ...state,
                hasError: false,
                isLoading: true
            };
        default:
            return state;
    }
};
